

























































import Vue from 'vue';
import Component from 'vue-class-component';
import UnityBridge from '@/unity-bridge';

import '@/globals';


@Component
export default class UnityPage extends Vue {

    public messages = new Array<string>();

    private ub: UnityBridge;
    private dbBackup: string;

    public beforeCreate() {
        this.ub = new UnityBridge();
        this.ub.addMessageHandler('unityMsg', (e) => this.onUnityMessage(e));
        this.ub.addMessageHandler('restoredDB', (e) => this.onRestoredDb(e));
    }

    public beforeDestroy() {
        this.ub.destroy();
    }

    public onUnityMessage(event: any) {
        const msg = event.detail.message;
        this.messages.push(msg);
    }

    public hideWebView() {
        this.ub.send('hideWebView');
    }

    public simpleCall() {
        this.ub.send('helloWorld');
    }

    public passData() {
        const someDummyObject = {
            dateTime: new Date(),
            message: 'Some String',
            count: 1337,
            luck: 0.6667,
        };

        this.ub.send('data', someDummyObject);
    }

    public async backup() {
        const dbData = await this.$store.db.backup();
        this.dbBackup = dbData;
        this.ub.send('backupDatabase', dbData);
    }

    public async clear() {
        await this.$store.db.clear();
        await this.$store.loadContent();
    }

    public async restore() {
        this.ub.send('restoreDatabase');
    }

    public async onRestoredDb(event: any) {
        const length = event.detail.length || 0;
        await this.$store.db.restore(event.detail);
        await this.$store.loadContent();
    }

    public async open_scene(arSceneName) {
        this.ub.send('launchArScene', arSceneName);
    }
}
